import React from 'react'
import Header from './components/Header'
import Footer from './components/Footer'
import PageHero from './components/PageHero'
import { getFestivals } from '../data/loadData'
import './Pages.css'

const PARAGRAPHS = [
  'Kültür Sanat ve Göç Etkinlikleri Merkezi Derneği, kısa adı ile KÜSAGEM, 2009 Haziran döneminde Ankara’da kurulmuş bir sivil toplum örgütüdür. Dernek, araştırmacılar, uygulama uzmanları ve sanatçıları bir araya getirerek kültür, sanat ve göç olguları ile ilgili toplum yararına projeler yapmak, yürütmek ve bu alanlarda çalışma yürüten bilim ve sanat insanlarını desteklemek amacı ile kurulmuştur.',
  'KÜSAGEM’e onu oluşturan birimler açısından bakıldığında, derneğin köklerinin, 1987’de Yeşim Eyüboğlu ve Serhan Sarıkaya tarafından kurulan ve günümüzde de faaliyetlerini sürdüren Tiyatro Özgün Deneme tiyatro topluluğuna kadar uzandığı görülecektir. KÜSAGEM aynı zamanda, bu günkü konumuyla üretkenlik temeli üzerinde varlık gösteren kültür ve sanat gönüllülerini buluşturan gönüllü bir yapıdır.',
  'Bu gönüllü yapı ile birlikte bir arada olmanın demokratik ve etik kurallarını oluşturma düşünü vurgulayan “ETHOS” sözcüğü ön takı olarak alınmış, proje aidiyeti Yeşim Eyüboğlu’na ait olan “ETHOS Ankara Uluslararası Tiyatro Festivali” etkinliği 2002 yılından bu yana düzenlenmeye başlanmıştır. “ETHOS Ankara Uluslararası Tiyatro Festivali” gelenekselleşen ve temalı bir uluslararası tiyatro festivali etkinliği oluşturma yolunda önemli bir mesafe alınmıştır.',
  'KÜSAGEM, aynı zamanda kültürel, sanatsal ve toplumsal gelişime katkı sunmak isteyen kurumlar, birlikler ve bireyler ile koordineli çalışmaların yürütüldüğü bir platform olarak da tasarlanmıştır. Çankaya Belediyesi, Büyükşehir Belediyesi, büyükelçilikler, Kültür ve Turizm Bakanlığı ve çeşitli kültür kurumları, tiyatro birlikleri ve sivil toplum kuruluşlarının katkıları ile 27 Mart Dünya Tiyatro Günü’nü içine alan ve 10 günlük süreyi kapsayan bir zaman diliminde yıllardır yürütülen “ETHOS Ankara Uluslararası Tiyatro Festivali”; 2019 yılında düzenlenen “Eğitimci Sanatçılar Buluşması” etkinliği KÜSAGEM etkinliklerinin en belirgin birer örneği durumundadır. KÜSAGEM aynı zamanda kentin kültür ve sanat dokusunu zenginleştirmek amacı ile “ETHOS BULUŞMALARI” gerçekleştirmekte; atölye, konser ve gösterilerden oluşan ve yıla yayılan etkinlikleri ile kentin kültürel dokusuna katkı sunmaktadır.',
]

const AIMS = [
  'Toplumun yaratıcı ve üretken yönlerini harekete geçirmek',
  'Sanata ilgi ve katılımı artırmak',
  'Göç, kadına yönelik şiddet, insan hakları ve hayvan hakları konularında ortaya çıkan kültürel ve sosyal dışlanmaları ortadan kaldırmaya dönük sanat yolu ile eğitim çalışmaları yürütmek',
  'Ülkenin kültürel ve sanatsal alt yapısının geliştirilmesi ve zenginleştirilmesine yönelik projeler ortaya koymak',
  'Bu amaçlar doğrultusunda farklı kurum ve oluşumlarla yerel, ulusal ve uluslararası projeler yürütmek',
  'Kültürler arası diyaloğu geliştirmek',
]

export default function About() {
  const festivalCount = getFestivals().length

  return (
    <React.Fragment>
      <Header />
      <PageHero
        eyebrow='KÜSAGEM'
        title='Hakkımızda'
        lede='Kültür Sanat ve Göç Etkinlikleri Merkezi Derneği'
      />

      <div className='pg' lang='tr'>
        <section className='pg-sun ab-facts' aria-label='Kısaca KÜSAGEM'>
          <div className='container'>
            <ul className='ab-facts-list'>
              <li className='ab-fact'>
                <span className='ab-fact-num'>1987</span>
                <p className='ab-fact-text'>Tiyatro Özgün Deneme kuruldu</p>
              </li>
              <li className='ab-fact'>
                <span className='ab-fact-num'>2009</span>
                <p className='ab-fact-text'>KÜSAGEM Ankara’da kuruldu</p>
              </li>
              <li className='ab-fact'>
                <span className='ab-fact-num'>{festivalCount}</span>
                <p className='ab-fact-text'>Ethos Ankara Tiyatro Festivali</p>
              </li>
            </ul>
          </div>
        </section>

        <section className='pg-paper pg-block' aria-label='Dernek'>
          <div className='container pg-split'>
            <figure className='ab-figure pg-sticky'>
              <img src='images/kusagem.jpg' alt='Ulusal Sempozyum “Kamusal Eğitim” oturumunda Doç. Dr. Ömer Adıgüzel, Dr. H. Serhan Sarıkaya ve Yeşim Eyüboğlu' />
              <figcaption>
                Ankara Üniversitesi Eğitim Bilimleri Enstitüsü, Ulusal Sempozyum “Kamusal Eğitim”:
                Ankara’da bir kültür sanat hareketi, ETHOS Ankara Uluslararası Tiyatro Festivali.
              </figcaption>
            </figure>
            <div className='pg-prose'>
              {PARAGRAPHS.map((text, index) => (
                <p key={index} className={index === 0 ? 'pg-lead' : undefined}>{text}</p>
              ))}
            </div>
          </div>
        </section>

        <section className='pg-night pg-block' aria-labelledby='ab-aims-title'>
          <div className='container'>
            <p className='pg-label'>KÜSAGEM</p>
            <h2 id='ab-aims-title' className='pg-heading'>TEMEL AMAÇLARIMIZ</h2>
            <ol className='ab-aims'>
              {AIMS.map((aim) => <li key={aim} className='ab-aim'>{aim}</li>)}
            </ol>
          </div>
        </section>
      </div>
      <Footer />
    </React.Fragment>
  )
}
